import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}><path d="M22.848 17.152H9.152a1.152 1.152 0 010-2.304h13.696a1.152 1.152 0 010 2.304" /></svg>;